import $http from '@/libs/axios'

class CategoryAPIs {
  static async delete(id: number) {
    return (await $http.delete(`store/categories/${id}`)).data
  }

  static async search(id: number) {
    return (await $http.get(`store/categories/list/${id}`)).data
  }

  static async process(data: any, catId?: number) {
    let url = 'store/categories/process'
    if (catId) url += `/${catId}`
    return (await $http.post(url, data)).data
  }
}

export default CategoryAPIs
